import React, { useEffect, useState } from 'react';
import { Button, Modal, Table } from 'antd';
import { ColumnType } from 'antd/es/table';
import dayjs from 'dayjs';
import { getHistory } from '../actions';

enum HistoryEvent {
    ARCHIVE = 'ARCHIVE',
    PUBLISH = 'PUBLISH',
    UPDATE = 'UPDATE',
}

interface ApiHistoryData {
    id: number;
    event: HistoryEvent;
    differences: unknown[] | null;
    createdBy: string;
    createdDate: string;
}

interface HistoryData {
    id: number;
    event: HistoryEvent;
    createdBy: string;
    createdDate: Date;
}

interface HistoryPagination {
    total: number;
    current: number;
    pageSize: number;
}

const eventLabels: Record<HistoryEvent, string> = {
    [HistoryEvent.ARCHIVE]: 'Перенесен в архив',
    [HistoryEvent.PUBLISH]: 'Опубликован',
    [HistoryEvent.UPDATE]: 'Редактирован',
};

interface ManageReestrHistoryModalProps {
    id: number;
    hideHistory: () => void;
}

const columns: ColumnType<HistoryData>[] = [
    {
        key: 'event',
        title: 'Событие',
        dataIndex: 'event',
        render: (value: HistoryEvent) => eventLabels[value],
    },
    {
        key: 'createdDate',
        title: 'Дата',
        dataIndex: 'createdDate',
        render: (value: Date) => dayjs(value).format('DD.MM.YYYY hh:mm:ss'),
    },
    {
        key: 'createdBy',
        title: 'Внес изменения',
        dataIndex: 'createdBy',
    },
];

const ManageReestrHistoryModal = ({ id, hideHistory }: ManageReestrHistoryModalProps) => {
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [dataSource, setDataSource] = useState<HistoryData[]>([]);
    const [pagination, setPagination] = useState<HistoryPagination>(null);

    const getHistoryPage = async (page = 1) => {
        setIsLoading(true);
        const data = await getHistory(id, page);

        const tableData: HistoryData[] = (data.content as ApiHistoryData[]).map((item) => ({
            id: item.id,
            event: item.event,
            createdBy: item.createdBy,
            createdDate: new Date(item.createdDate),
        }));

        setDataSource(tableData);
        setPagination({ current: data.number + 1, total: data.totalElements, pageSize: data.size });
        setIsLoading(false);
    };

    useEffect(() => {
        if (id) {
            getHistoryPage();
        }
    }, [id]);

    return (
        <Modal
            title="История изменений документа"
            open={Boolean(id)}
            onCancel={hideHistory}
            footer={[
                <Button
                    type="primary admin"
                    onClick={hideHistory}
                >
                    Закрыть
                </Button>,
            ]}
        >
            <Table
                columns={columns}
                rowKey={'id'}
                dataSource={dataSource}
                className="my-3"
                loading={isLoading}
                pagination={{
                    ...pagination,
                    hideOnSinglePage: true,
                    onChange(page) {
                        getHistoryPage(page);
                    },
                }}
            />
        </Modal>
    );
};

export default ManageReestrHistoryModal;
